import { C } from "../../lib/constants";

export const FileUploadCard = ({id, value, onChange, icon, title, sub}) => {
  const filled = Boolean(value);
  const fileName = value instanceof File ? value.name : "";

  return (
    <label
      htmlFor={id}
      style={{
        background:filled?C.greenL:C.surface,
        border:`1.5px dashed ${filled?C.green:C.border}`,
        borderRadius:16,
        padding:"18px 12px",
        textAlign:"center",
        cursor:"pointer",
        transition:"all 0.2s",
        display:"block",
      }}
      onMouseEnter={e=>{if(!filled)e.currentTarget.style.borderColor=C.accent;}}
      onMouseLeave={e=>{if(!filled)e.currentTarget.style.borderColor=C.border;}}
    >
      <input
        id={id}
        type="file"
        accept="image/*"
        style={{display:"none"}}
        onChange={(e)=>onChange(e.target.files && e.target.files[0])}
      />
      <div style={{fontSize:26,marginBottom:6}}>{filled?"✅":icon}</div>
      <div style={{color:filled?C.green:C.text,fontSize:13,fontWeight:700,marginBottom:2}}>
        {filled?"¡Listo!":title}
      </div>
      <div style={{color:C.muted,fontSize:11,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
        {filled ? (fileName || "Cargado correctamente") : sub}
      </div>
    </label>
  );
};

export const PhotoGrid = ({form, upd}) => {
  const rawPhotos = Array.isArray(form.portfolioPhotos) ? form.portfolioPhotos : [];
  const labels = ["Trabajo terminado","Detalle de obra","Antes y después","Material usado","En proceso","Vista general"];

  const setPhoto = (index, file) => {
    if (!file) return;

    const nextPhotos = [...rawPhotos];
    nextPhotos[index] = {
      label: labels[index],
      uploaded: true,
      name: file.name || `foto-${index + 1}`,
      file,
      preview: URL.createObjectURL(file),
    };

    upd("portfolioPhotos", nextPhotos);
  };

  const removePhoto = (index) => {
    const nextPhotos = [...rawPhotos];
    nextPhotos[index] = null;
    upd("portfolioPhotos", nextPhotos);
  };

  return (
    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8}}>
      {Array.from({length:6}).map((_,i)=>{
        const photo = rawPhotos[i];
        const filled = Boolean(photo && photo.uploaded);

        return (
          <div key={i} style={{position:"relative"}}>
            {filled ? (
              <div
                style={{
                  height:88,
                  borderRadius:14,
                  border:`1.5px solid ${C.green}`,
                  background:C.greenL,
                  position:"relative",
                  overflow:"hidden",
                }}
              >
                {photo.preview ? (
                  <img
                    src={photo.preview}
                    alt={photo.label || `Foto ${i+1}`}
                    style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}}
                  />
                ) : (
                  <div style={{height:"100%",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
                    <div style={{fontSize:20,marginBottom:3}}>✅</div>
                    <div style={{color:C.green,fontSize:8,fontWeight:700,textAlign:"center",padding:"0 4px"}}>
                      {photo.label || labels[i]}
                    </div>
                  </div>
                )}

                <div style={{
                  position:"absolute",
                  left:0,
                  right:0,
                  bottom:0,
                  background:"rgba(0,0,0,0.55)",
                  color:"#fff",
                  fontSize:8,
                  fontWeight:700,
                  padding:"4px 5px",
                  textAlign:"center",
                  overflow:"hidden",
                  textOverflow:"ellipsis",
                  whiteSpace:"nowrap"
                }}>
                  {photo.label || labels[i]}
                </div>

                <button
                  type="button"
                  onClick={(e)=>{e.preventDefault(); e.stopPropagation(); removePhoto(i);}}
                  style={{
                    position:"absolute",
                    top:4,
                    right:4,
                    background:C.surface,
                    border:`1px solid ${C.border}`,
                    color:C.muted,
                    borderRadius:"50%",
                    width:20,
                    height:20,
                    cursor:"pointer",
                    fontSize:10,
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"center",
                  }}
                >
                  ✕
                </button>
              </div>
            ) : (
              <label
                htmlFor={`portfolio-photo-${i}`}
                style={{
                  height:88,
                  borderRadius:14,
                  border:`1.5px dashed ${C.border}`,
                  background:C.surface,
                  display:"flex",
                  flexDirection:"column",
                  alignItems:"center",
                  justifyContent:"center",
                  cursor:"pointer",
                  transition:"all 0.2s",
                }}
                onMouseEnter={e=>{e.currentTarget.style.borderColor=C.accent;}}
                onMouseLeave={e=>{e.currentTarget.style.borderColor=C.border;}}
              >
                <div style={{fontSize:18,marginBottom:3,color:C.muted}}>📷</div>
                <div style={{color:C.muted,fontSize:9,textAlign:"center"}}>Foto {i+1}</div>
              </label>
            )}

            <input
              id={`portfolio-photo-${i}`}
              type="file"
              accept="image/*"
              style={{display:"none"}}
              onChange={(e)=>setPhoto(i, e.target.files && e.target.files[0])}
            />
          </div>
        );
      })}
    </div>
  );
};
